import styled from "styled-components";

export const TimerContainer = styled.time`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space[2]};
  font-family: ${({ theme }) => theme.fonts.bold};
  font-size: ${({ theme }) => theme.fontSizes[8]};
  font-weight: 800;
`;

export const ReducedMotionTime = styled.time`
  display: block;
  font-family: ${({ theme }) => theme.fonts.bold};
  font-size: ${({ theme }) => theme.fontSizes[3]};
  text-align: center;
`;

export const TimeUnit = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 52px;
`;

export const TimeLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSizes[0]};
`;

export const Separator = styled.span`
  padding-bottom: ${({ theme }) => theme.space[4]};
`;
